import { render } from "./UserInstruction.vue?vue&type=template&id=b74ca0be&scoped=true"
import script from "./UserInstruction.vue?vue&type=script&lang=js"
export * from "./UserInstruction.vue?vue&type=script&lang=js"

import "./UserInstruction.vue?vue&type=style&index=0&id=b74ca0be&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74ca0be"]])

export default __exports__